import { render, staticRenderFns } from "./CardFare.vue?vue&type=template&id=cf83fa12&"
import script from "./CardFare.vue?vue&type=script&lang=js&"
export * from "./CardFare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports